<div class="modal-content min-h-xl d-flex flex-column h-100">
  @if (newsDetails$ | async; as news) {
    <div class="modal-news overflow-y-auto overflow-x-hidden">
      <div class="row">
        <div class="col-4">
          <div class="apm-card-image">
            <apm-news-img [fileName]="news.coverFilename" [imgAlt]="news.title"></apm-news-img>
          </div>
        </div>
        <div class="apm-card-content d-flex flex-column col-8">
          <div class="created-at italic mb-3">{{ news.created.at | momentDate }}</div>
          <hr class="gray-divider-1" />
          <div class="text-md bold mt-3 mb-3">{{ news.title }}</div>
          <hr class="gray-divider-1" />
          <div class="created-at italic mt-3">{{ 448806 | apmTranslate }}</div>
          @for (tag of tags(); track tag) {
            <div class="created-at text">{{ tag }}</div>
          }
        </div>
      </div>
      <hr class="gray-divider-1 mt-4 mb-3" />
      <div class="text-break" [innerHTML]="news.content"></div>
    </div>
  }

  @if (hasError()) {
    <p>{{ 448881 | apmTranslate }}</p>
  }

  <div class="mt-auto d-flex flex-column pt-2">
    <apm-button variant="secondary" (click)="closeDialog()">{{ '444400' | apmTranslate }}</apm-button>
  </div>
</div>

<apm-windowed-spinner [show]="isLoading()"></apm-windowed-spinner>
